import InputLabel from '@mui/material/InputLabel';
import './label.scss'
import classNames from 'classnames';

const Label = (props) => {
    const classes = classNames('label', props.className);
    return <InputLabel {...props} className={classes}>{props.children}</InputLabel>
};

export default Label;